// app/components/ui/common/HomeFaqs.jsx
"use client";

import React, { useState, useEffect } from "react";
import { cx } from "class-variance-authority";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "../../../../app/globals.css";
import { homePageFaqData } from "./HomeFaqsData";

export const dynamic = "force-dynamic";

const HomeFaqs = () => {
    const [isOpen, setIsOpen] = useState(0);
    const [mounted, setMounted] = useState(false);

    const faqShadow = {
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
    };

    const renderers = {
        a: ({ href, children }) => (
            <a href={href} className="custom-link">
                {children}
            </a>
        ),
    };

    useEffect(() => {
        setMounted(true);
    }, []);

    // Render nothing during SSR to avoid FAQ content in server-side HTML
    if (!mounted) {
        return null;
    }

    return (
        <div>
            <div className="container mx-auto mt-16 md:mt-[140px] px-4 md:px-24 lg:px-24 xl:px-0">
                <div className="w-full text-center">
                    <h2
                        className={`text-2xl lg:text-4xl !leading-snug font-bold font-manrope text-black flex justify-center items-center`}
                    >
                        Frequently Asked Questions
                    </h2>
                </div>
            </div>

            <div className="container px-4 mx-auto my-20 mt-10 md:px-24 lg:px-24 xl:px-0">
                {homePageFaqData?.map((item, ind) => (
                    <div className="my-4" key={item?.id || ind}>
                        <div
                            style={faqShadow}
                            onClick={() =>
                                setIsOpen(item?.id === isOpen ? 0 : item?.id)
                            }
                            className="rounded-2xl w-full md:max-w-7xl md:mx-auto bg-white"
                        >
                            <div className="flex items-center justify-start gap-5 p-4 text-base font-semibold cursor-pointer">
                                {isOpen === item?.id ? " - " : " + "}
                                <h3>{item?.question}</h3>
                            </div>
                        </div>
                        <div
                            className={cx(
                                isOpen === item?.id ? "h-auto" : "hidden h-0",
                                "w-full md:max-w-7xl md:mx-auto p-4 transition-[height] ease-in-out duration-500"
                            )}
                        >
                            <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={renderers}
                            >
                                {item?.answer}
                            </ReactMarkdown>

                            {item?.keyPoints && (
                                <span>
                                    {item?.keyPoints?.map((points, index) => (
                                        <li key={index} className="list-disc">
                                            <span>{points?.point}</span>
                                            <br />
                                        </li>
                                    ))}
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HomeFaqs;
